/* global drupalSettings */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import utils from '../assets/utils'
import helpers from './store-helpers'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    endpoints: {
      dvr: { // DVR
        streamUrl: '/api/v1/stream/dvronly',
        url: '/api/v1/playlists/dvronly',
        playlists: []
      },
      vod: { // VOD
        streamUrl: '/api/v1/stream/vodonly',
        url: '/api/v1/playlists/vodonly',
        playlists: []
      },
      default: {
        url: '/api/v1/playlists',
        playlists: []
      }
    },
    order: ['dvr', 'vod', 'default'], // to map and set order of different endpoints
    apiHost: 'https://api-etlive.etonline.com',
    resources: {
      current: null,
      next: null,
      live: null,
      isLive: false,
      tray: null

    },
    daiParams: '/8264/vaw-ctd/mobile_web/etonline_mobile',
    livePageRoutes: [
      '/live',
      '/live/:slug',
      '/embed/live'
    ],
    currentRoute: '/live',
    startingRoute: '/live',
    liveCategory: 'Latest',
    breakpoint: 'xs',
    loading: true,
    isPlaying: false,
    trayUpdated: false,
    isAdPlaying: false,
    isPlayerReady: false,
    isPlayerOnly: false,
    playerHasOverlay: false,
    playerIsStopped: false,
    isPreRoll: false,
    partner: 'partner',
    contentTimeForAds: 480,
    configSettings: null,
    dotqProjectId: 10000,
    dotqPixelId: 10072918,
    dotqet: 'custom',
    dotqec: 'stream',
    dotqea: 'live stream',
    fontLoaded: false,
    mediaAutoplayCustom: false,
    default_share_image: 'https://etlive-fastly-cbsaavideo-com.global.ssl.fastly.net/images/et_default_share.jpg',
    default_preview_image: 'https://etlive-fastly-cbsaavideo-com.global.ssl.fastly.net/images/watchnow.png',
    default_stopped_image: 'https://etlive-fastly-cbsaavideo-com.global.ssl.fastly.net/images/stopscreen.png',
    mutedAutoplayStreamID: 'S_bSkl7NjAiJD_uCxJKLY2DjHiaA5j8K',
    continuousPlay: 0
  },
  getters: {
    /**
     * Returns route's name by path
     */
    getRouteNameByPath: (state) => (routes, path) => {
      let name = routes.filter(route => route.path.includes(path))[0].name
      return name === 'live-stream' ? 'live' : name
    },
    /**
     * Returns formatted playlist
     *
     * @param {object} state
     */
    playlists (state) {
      let playlists = []

      return state.order.reduce((playlists, endpoint) => {
        // filter for playlists that are not empty
        return playlists
          .concat(
            state.endpoints[endpoint].playlists !== null
              ? state.endpoints[endpoint].playlists.filter((playlist) => playlist.items.length > 0)
              : []
          )
      }, playlists)
    },

    /**
     * Get the live's story title
     *
     * @param {object} state
     * @param {object} getters
     */
    getRealTimeLiveTitle (state, getters) {
      return getters.playlists[0].items[0].StoryHead
    },

    /**
     * Checks if the starting route was a Live or DVR page
     * @returns {boolean}
     */
    wasLivePage (state) {
      return state.startingRoute === '/live' || state.startingRoute === '/live/:slug'
    },

    /**
     * Checks if the starting route was a Video or VOD page
     * @returns {boolean}
     */
    wasVideoOrVODPage (state) {
      return state.startingRoute === '/video' || state.startingRoute === '/media/videos/:slug' || state.startingRoute === '/media/video/:slug'
    },

    /**
     * Checks if the starting route was a Video Node page
     * @returns {boolean}
     */
    wasVODPage (state) {
      return state.startingRoute === '/media/videos/:slug' || state.startingRoute === '/media/video/:slug'
    },

    /**
     * Checks if current route is live or DVR page
     * @returns {boolean}
     */
    isLivePage (state) {
      return state.livePageRoutes.includes(state.currentRoute)
    },

    /**
     * Checks if current route is DVR page
     * @returns {boolean}
     */
    isDVRPage (state) {
      return state.currentRoute === '/live/:slug'
    },

    /**
     * Checks if current route is VOD page
     * @returns {boolean}
     */
    isVODPage (state) {
      return state.currentRoute === '/media/videos/:slug' || state.currentRoute === '/media/video/:slug'
    },

    /**
     * Checks to see if in Drupal environment.
     * @returns {boolean}
     */
    isDrupal () {
      return typeof drupalSettings !== 'undefined'
    },

    /**
     * Checks to see if it is a video node.
     * @returns {boolean}
     */
    isVideoNode () {
      return typeof drupalSettings !== 'undefined' && drupalSettings.currentVideoNode
    },

    /**
     * Check to see if live is enabled.
     * @param state
     */
    isLiveEnabled (state, getters) {
      if (getters.isDrupal) {
        if ((drupalSettings.et_live && drupalSettings.et_live.live_status) || getters.wasLivePage) {
          return true
        }
        return false
      } else {
        return true
      }
    },

    /**
     * Checks if it is a live video currently
     *
     * @returns {boolean}
     */
    isLiveVideo: (state) => (resource) => {
      return resource.Category === state.liveCategory && resource.EndTime === 0
    }
  },
  mutations: {
    /**
     * Updates playlists for each endpoint
     */
    setPlaylists (state, payload) {
      // updates only playlists that need to be updated
      payload.order.map((endpoint, index) => {
        if (endpoint === 'default') {
          state.endpoints['dvr'].playlists = [payload.responses[index].playlists.shift()]
          state.endpoints['vod'].playlists = payload.responses[index].playlists
        } else {
          if (typeof payload.responses[index] !== 'undefined') {
            state.endpoints[endpoint].playlists = payload.responses[index].playlists
          } else {
            if (payload.responses.playlists.length) {
              state.endpoints[endpoint].playlists = payload.responses.playlists
            }
          }
        }
      })
    },

    /**
     * Checks if current add is pre roll ad
     * @returns {boolean}
     */
    setIsPreRoll (state, val) {
      state.isPreRoll = val
    },

    /**
     * Adds new endpoint to endpoints
     *
     * @param {object} state
     * @param {object} payload
     */
    addToEndpoints (state, payload) {
      state.endpoints[payload.key] = payload.endpoint
      if (payload.prepend) {
        state.order.unshift(payload.key)
      } else {
        state.order.push(payload.key)
      }
    },

    /**
     * Removes endpoint from endpoints
     *
     * @param {object} state
     * @param {string} key
     */
    removeFromEndpoints (state, key) {
      delete state.endpoints[key]
      state.order = state.order.filter((order) => {
        return order !== key
      })
    },

    /**
     * Updates state.resources.  Sets the current and next videos to be played.
     * @param {object} state
     * @param {array} item
     * @param {number} item.category
     * @param {number} item.item
     */
    setResources (state, {slug, playlists, tray}) {
      let isLivePage = state.livePageRoutes.includes(state.currentRoute)
      let itemPos = helpers.getCategoryAndItemIndexes(playlists, slug, tray)
      let [category, item] = itemPos !== null ? itemPos : [0, 0]
      let context = playlists[category].items[item]
      let playlist = helpers.preparePlaylist(playlists[category].items, item, (state.liveCategory === context.Category && isLivePage))
      let playback = helpers.preparePlayback(playlist, (state.liveCategory === context.Category && isLivePage)) // to specify order, ie. DVR goes backwards for some reason
      let current = playback[0]
      let next = 1 in playback ? playback[1] : null

      if (playlist[current]) {
        state.resources = {
          current: playlist[current],
          next: playlist[next] || null,
          live: playlists[0].items[0],
          isLive: playlist[current].Category === state.liveCategory && playlist[current].EndTime === 0,
          tray: tray || playlists[category].category
        }
      }
    },

    /**
     * Updates state.breakpoint
     */
    setBreakpoint (state, breakpoint) {
      state.breakpoint = breakpoint
    },

    /**
     * Updates state.loading
     */
    setLoading (state, loading) {
      state.loading = loading
    },

    /**
     * Checks to see if Live page.
     * @returns {boolean}
     */
    setCurrentRoute (state, routeType) {
      state.currentRoute = routeType
    },

    /**
     * Checks to see if DVR page.
     * @returns {boolean}
     */
    setStartingRoute (state, routeType) {
      state.startingRoute = routeType
    },

    /**
     *
     * @param state
     * @param val
     */
    setConfigSettings (state, val) {
      if (val) {
        state.configSettings = val
      }
    },

    /**
     * Updates state.settings
     */
    setContentTimeForAds (state, val) {
      state.contentTimeForAds = val
    },

    /**
     * Updates state.isPlaying
     */
    setIsPlaying (state, isPlaying) {
      state.isPlaying = isPlaying
    },

    /**
     * Updates state.trayUpdated
     */
    setTrayUpdated (state, trayUpdated) {
      state.trayUpdated = trayUpdated
    },

    /**
     * Updates state.isPlaying
     */
    setIsAdPlaying (state, isAdPlaying) {
      state.isAdPlaying = isAdPlaying
    },

    /**
     * Updates state.isPlayerReady
     */
    setIsPlayerReady (state, playerReady) {
      state.isPlayerReady = playerReady
    },

    /**
     * Updates state.isPlayerReady
     */
    setPlayerHasOverlay (state, enable) {
      state.playerHasOverlay = enable
    },

    /**
     * Updates state.isPlayerReady
     */
     setPlayerIsStopped (state, stopped) {
      state.playerIsStopped = stopped
    },

    /**
     * Updates state.isPlayerOnly.  To disable all components except for Player.
     */
    setIsPlayerOnly (state, playerOnly) {
      state.isPlayerOnly = playerOnly
    },

    /**
     * Updates state.partner
     */
    setPartner (state, partner) {
      state.partner = partner
    },

    /**
     * Updates state.fontLoaded
     */
    setFontLoaded (state, loaded) {
      state.fontLoaded = loaded
    },

    /**
     * Updates state.continuousPlay
     */
    setContinuousPlay (state, continuousPlay) {
      state.continuousPlay = continuousPlay
    },

    /**
     * Sets if Media Autoplay custom?
     *
     * @param {object} state
     * @param {boolean} autoplay
     */
    setMediaAutoplayCustom (state, autoplay) {
      state.mediaAutoplayCustom = autoplay
    },

    /**
     * Sets API host
     *
     * @param {object} state
     * @param {string} apiHost
     */
    setApiHost (state, apiHost) {
      state.apiHost = apiHost
    },

    /**
     * Sets DAI parameters
     *
     * @param {object} state
     * @param {object} params
     */
    setDAIParams (state, params) {
      state.daiParams = params
    }
  },
  actions: {
    /**
     * Run these on init
     */
    appInit ({dispatch, commit, getters}, {slug = null, routeType = '/live'}) {
      // for route checks throughout the app
      commit('setStartingRoute', routeType)
      commit('setCurrentRoute', routeType)

      // Do Drupal things if global drupalSettings object exists, after getting apiHost
      if (getters.isDrupal) {
        dispatch('prepareForDrupal', {routeType})
      }

      let endpoint = null

      if (!getters.isLiveEnabled) {
        commit('removeFromEndpoints', 'dvr')
        commit('removeFromEndpoints', 'default')
      } else {
        endpoint = 'default'
      }

      // then get settings
      dispatch('getSettings').then(() => {
        // then whatever afterwards
        dispatch('getPlaylists', {slug, endpoint: endpoint, init: true}).then(() => {
          commit('setLoading', false)
          let endpoints = ['dvr', 'vod']
          endpoints.forEach(function(i, v){
            dispatch('getUpdates', {endpoint: i})
          })
        })
      })
    },

    /**
     * Do these things for Drupal
     */
    prepareForDrupal ({commit}, {routeType = '/live'}) {
      // Drupal settings apiHost.
      if (drupalSettings.hasOwnProperty('videoApiHost') && drupalSettings.videoApiHost !== null) {
        commit('setApiHost', drupalSettings.videoApiHost)
      }
      // Drupal settings etLivePartner
      if (drupalSettings.hasOwnProperty('etLivePartner')) {
        commit('setPartner', drupalSettings.etLivePartner)
      }

      // replace default DAI Params with device specific values
      let iuDeviceValue = utils.isMobile() ? 'mobile_web/etonline_mobile' : 'desktop/etonline'
      commit('setDAIParams', '/8264/vaw-ctd/' + iuDeviceValue)

      // replace default DAI Params with these if it is an embed page
      if (drupalSettings.hasOwnProperty('etLivePartner') && routeType === '/embed/live') {
        commit('setDAIParams', '/8264/vaw-ctd/' + iuDeviceValue + '_' + drupalSettings.etLivePartner + '&description_url=https://www.etonline.com/live')
      }

      // This property is available if query parameter "playeronly" is set.
      // This is for disabling certain components to use for a page for embeds.
      if (drupalSettings.hasOwnProperty('isPlayerOnly') && drupalSettings.isPlayerOnly === 'true') {
        commit('setIsPlayerOnly', true)
      }
    },

    /**
     * Get Settings values from Fusion API
     */
    getSettings ({commit, state}) {
      return new Promise((resolve, reject) => {
        axios.get(state.apiHost + '/api/v1/settings')
          .then((response) => {
            commit('setConfigSettings', response.data)
            commit('setContentTimeForAds', response.data.contentTimeForAds)
            resolve()
          })
          .catch(function (error) {
            // handle error
            console.log(error)
            resolve(error)
          })
      })
    },

    async getUpdates({dispatch, commit, getters, state}, {endpoint = 'dvr'}) {
      let vodMsgServer;
      let dvrMsgServer;
      let filteredOrder = []

      if(endpoint === 'vod') {
        let order = [endpoint]
        filteredOrder = order.filter((endpoint) => {
          return state.endpoints[endpoint].streamUrl !== null
        })
        vodMsgServer = new EventSource(state.apiHost + state.endpoints[endpoint].streamUrl);
        vodMsgServer.addEventListener(endpoint+'Update', message => {
          let data = message.data
          commit('setPlaylists', {order: filteredOrder, responses: JSON.parse(data)})
        }, false)
        vodMsgServer.onmessage = function(data) {
          console.warn('Received a message w/o an event!', data);
        }

      } else {
        let order = [endpoint]
        filteredOrder = order.filter((endpoint) => {
          return state.endpoints[endpoint].streamUrl !== null
        })
        dvrMsgServer = new EventSource(state.apiHost + state.endpoints[endpoint].streamUrl);
        dvrMsgServer.addEventListener(endpoint+'Update', message => {
          let data = message.data
          commit('setPlaylists', {order: filteredOrder, responses: JSON.parse(data)})
          if (state.resources.current === null || state.resources.isLive) {
            commit('setResources', {
              slug: null,
              playlists: getters.playlists,
              tray: null
            })
          }
        }, false);
        dvrMsgServer.onmessage = function(data) {
          console.warn('Received a message w/o an event!', data);
        }
      }
    },

    /**
     * Get playlists by endpoint
     */
    async getPlaylists ({dispatch, commit, getters, state}, {slug = null, endpoint = null, init = false}) {
      return new Promise((resolve, reject) => {
        // if the 'endpoint' is passed as an argument, that means this method is called as a refresh, updating data on a specific endpoint
        let order = [endpoint]
        let filteredOrder = []
        let getPromises = []

        if (endpoint === null) {
          // use a copy of 'order' for this instance.  it's not likely, but the order of playlists may change while this call is happening
          order = state.order.slice()
        }

        // only include endpoints that have a url to make axios get calls
        if (endpoint !== 'default') {
          filteredOrder = order.filter((endpoint) => {
            return state.endpoints[endpoint].url !== null
          })

          getPromises = filteredOrder.map((endpoint) => {
            return axios.get(state.apiHost + state.endpoints[endpoint].url)
          })
        }

        axios.all(getPromises)
          .then(async (responses) => {
            commit('setPlaylists', {
              order: filteredOrder,
              responses: responses.map((response) => {
                return response.data
              })
            })

            // because this only happens on initial load
            if (init) {
              // returns null if slug does not exist in playlists
              let itemPos = helpers.getCategoryAndItemIndexes(getters.playlists, slug)

              if (itemPos === null) {
                // check if Video Node - for videos that are in Drupal, but does not exist on /live and video pages
                if (getters.isVideoNode) {
                  // this will call the addVideoFromDrupal mutation if slug does not exist in playlists
                  await dispatch('addVideoFromDrupal')
                } else {
                  await dispatch('addExpiredDVRToTray', {slug})
                }
              }
            }

            if (state.resources.current === null || state.resources.isLive) {
              commit('setResources', {
                slug: slug,
                playlists: getters.playlists,
                tray: null
              })
            }
            resolve()
          })
          .catch(function (error) {
            // handle error
            console.log(error)
            resolve(error)
          })
      })
    },

    /**
     * Add single video from Drupal
     */

    addVideoFromDrupal ({commit}) {
      return new Promise((resolve, reject) => {
        let playlists = [
          {
            category: 'Hidden',
            items: [
              drupalSettings.currentVideoNode
            ]
          }
        ]
        commit('addToEndpoints', {
          key: 'hidden',
          endpoint: helpers.prepareEndpointObject(playlists),
          prepend: false
        })
        resolve()
      })
    },

    /**
     * Add DVR that has been expired from tray if available in Fusion
     */
    addExpiredDVRToTray ({dispatch, commit, state}, {slug = null}) {
      return new Promise((resolve, reject) => {
        dispatch('getExpiredDVR', {slug}).then((data) => {
          if (typeof data === 'object' && data.hasOwnProperty('items')) {
            let playlists = [
              {
                category: 'Hidden',
                items: data.items.slice().map((item) => {
                  if (item.ThumbnailURL) {
                    // update thumbnail dimensions
                    item.ThumbnailURL = utils.newImageSize(item.ThumbnailURL)
                  } else {
                    item.ThumbnailURL = state.default_share_image
                  }
                  return item
                })
              }
            ]
            commit('addToEndpoints', {
              key: 'hidden',
              endpoint: helpers.prepareEndpointObject(playlists),
              prepend: false
            })
          }
          resolve()
        })
      })
    },

    /**
     * Gets expired DVR data from Fusion API
     */
    getExpiredDVR ({state}, {slug = null}) {
      return new Promise((resolve, reject) => {
        if (slug !== null) {
          // state.apiHost because Drupal does not have this endpoint available
          axios.get(state.apiHost + '/api/v1/dvr/' + slug)
            .then((response) => {
              resolve(response.data)
            })
            .catch(function (error) {
              // handle error
              console.log(error)
              resolve(error)
            })
        } else {
          resolve()
        }
      })
    }
  },

  strict: process.env.NODE_ENV !== 'production'
})
